import { useForm, Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account {
  id: number
  name: string
  slug: string
}

interface Customer {
  id: number
  name: string
  email: string
  phone: string
  address: string
  tax_id: string
  city: string
  birth_date: string
  is_wholesale: boolean
}

interface Props {
  customer: Customer
  account: Account
  errors?: string[]
  permissions?: {
    can_manage_customers: boolean
  }
}

export default function CustomersEdit({ customer, account, errors, permissions }: Props) {
  const { data, setData, put, processing } = useForm({
    name: customer.name || '',
    email: customer.email || '',
    phone: customer.phone || '',
    address: customer.address || '',
    tax_id: customer.tax_id || '',
    city: customer.city || '',
    birth_date: customer.birth_date || '',
    is_wholesale: customer.is_wholesale || false,
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/${account.slug}/customers/${customer.id}`)
  }

  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">Editar Cliente</h1>

        {errors && errors.length > 0 && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
            {errors.map((error, i) => <p key={i}>{error}</p>)}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
            <input type="text" value={data.name} onChange={(e) => setData('name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" value={data.email} onChange={(e) => setData('email', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
            <input type="text" value={data.phone} onChange={(e) => setData('phone', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">RTN</label>
            <input type="text" value={data.tax_id} onChange={(e) => setData('tax_id', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ciudad</label>
            <input type="text" value={data.city} onChange={(e) => setData('city', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de nacimiento</label>
            <input type="date" value={data.birth_date} onChange={(e) => setData('birth_date', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
            <textarea value={data.address} onChange={(e) => setData('address', e.target.value)} rows={2} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="is_wholesale"
              checked={data.is_wholesale}
              onChange={(e) => setData('is_wholesale', e.target.checked)}
              className="w-4 h-4 text-[#FFC107] border-gray-300 rounded focus:ring-[#FFC107]"
            />
            <label htmlFor="is_wholesale" className="text-sm font-medium text-gray-700 cursor-pointer">
              Cliente mayorista
            </label>
          </div>

          <div className="flex justify-end space-x-2">
            <Link href={`/${account.slug}/customers`} className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50">Cancelar</Link>
            <button type="submit" disabled={processing} className="bg-[#FFC107] text-[#202020] px-4 py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
              {processing ? 'Guardando...' : 'Actualizar'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  )
}
